var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../styles/ServerConfigSection.css";
function ServerOptionCard(props) {
    return (_jsxs("button", __assign({ type: "button", className: "server-option-card ".concat(props.selected ? "selected" : ""), onClick: props.onSelect }, { children: [_jsx("span", { className: "server-option-card-radio ".concat(props.selected ? "checked" : "") }), _jsx("span", __assign({ className: "server-option-card-icon" }, { children: props.icon })), _jsxs("span", __assign({ className: "server-option-card-text" }, { children: [_jsx("span", __assign({ className: "server-option-card-title" }, { children: props.title })), _jsx("span", __assign({ className: "server-option-card-description" }, { children: props.description }))] }))] })));
}
export default ServerOptionCard;
